import * as React from 'react';
import { Image } from '@cian/ui-kit';

import image from './assets/image.png';
import { Block } from '../Block';
import * as styles from './styles.css';
import { Typography } from '../Typography';

interface IProps {
  children?: React.ReactNode;
}

export const NotFound: React.FC<IProps> = ({ children }) => {
  return (
    <div className={styles['container']}>
      <Image src={image} width={200} height="auto" />
      <Block marginTop={4}>
        <Typography.Title level={5}>Ничего не найдено</Typography.Title>
      </Block>

      {children}
    </div>
  );
};

NotFound.displayName = 'NotFound';
